import React from 'react';

const LOADER_TEXT =
  'Generating final report...Results below are preliminary and will update. This message will disappear when complete.';

export const InvestigationReportGenerationLoader: React.FC = () => {
  return (
    <div className="my-2 flex items-center gap-3 rounded-xl border border-orange-200 bg-gradient-to-br from-orange-50 to-orange-100 px-4 py-2.5 text-orange-800 shadow-[0_1px_3px_rgba(249,115,22,0.08),0_4px_16px_rgba(249,115,22,0.04)] dark:border-gray-600">
      <div className="h-[18px] w-[18px] flex-shrink-0 animate-spin rounded-full border-[2.5px] border-orange-200/60 border-t-orange-500 dark:border-gray-600/60" />
      <span className="text-sm font-medium tracking-[-0.01em] text-orange-800">
        {LOADER_TEXT}
      </span>
    </div>
  );
};

export default InvestigationReportGenerationLoader;
